import React from "react";
import { Box, Chip } from "@material-ui/core";
import { css } from "@emotion/css";
import { PartFormData } from "../../types";

export type SelectedScreen =
  | { kind: "lesson"; partIndex: number }
  | { kind: "quiz"; partIndex: number; questionIndex: number };

type Props = {
  parts: PartFormData[];
  selected: SelectedScreen;
  onChange: (s: SelectedScreen) => void;
};

const ScreenSelector: React.VFC<Props> = ({ parts, selected, onChange }) => (
  <Box className={styles.wrap}>
    {(parts ?? []).map((part, pi) => (
      <Box key={pi} className={styles.group}>
        <Chip
          label={`Part ${pi + 1} lesson`}
          color={selected.kind === "lesson" && selected.partIndex === pi ? "primary" : "default"}
          size="small"
          onClick={() => onChange({ kind: "lesson", partIndex: pi })}
        />
        {(part.questions ?? []).map((_q, qi) => (
          <Chip
            key={qi}
            label={`Q${qi + 1}`}
            size="small"
            color={
              selected.kind === "quiz" && selected.partIndex === pi && selected.questionIndex === qi
                ? "primary"
                : "default"
            }
            onClick={() => onChange({ kind: "quiz", partIndex: pi, questionIndex: qi })}
          />
        ))}
      </Box>
    ))}
  </Box>
);

export default React.memo(ScreenSelector);

const styles = {
  wrap: css`
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 8px;
  `,
  group: css`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  `,
};
